<template>
  <div class="showMsg">
    <div v-if="type==true">
      <img src="../assets/success.png" alt />
      <div>{{showMsgText?showMsgText:'领取成功'}}</div>
    </div>
    <div v-else>
      <img src="../assets/failed.png" alt />
      <div>{{showMsgText}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "showMsg", // 定义的组件名称 使用时写法：loading
   data() {
    return {
      type:this.$store.state.showMsgUrl,
      showMsgText:this.$store.state.showMsgText,
    };
  },
  mounted(){
    setTimeout(() => {
      this.$store.commit("showMsg", {show:false,type:false});//显示领取失败
    }, 2000);
  }
};
</script>

<style scoped>
.showMsg {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  z-index: 1000;
 display: flex;
 justify-content: center;
 align-items: center
}
.showMsg>div{
  width: 3rem;
   display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 0.2rem;
  border: 1px solid #e5e5e5;
  background: white;
  padding: 0.4rem;
  text-align: center
}
.showMsg div img {
  width: 1rem;
  height: 1rem;
}
.showMsg div div {
  font-size: 0.34rem;
  margin-top: 0.2rem
}
</style>